import React, { useState, useRef, useEffect } from 'react';
import './Picker.css';

function Picker({
  label,
  value,
  onChange,
  children,
  id,
  className = '',
  error,
  disabled,
  required,
  autoFocus,
  hideLabelOnSelect = false,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!value);
  const selectRef = useRef(null);

  useEffect(() => {
    setHasValue(value !== undefined && value !== null && String(value).length > 0);
  }, [value]);

  return (
    <div className={`modern-picker-wrapper ${className} ${error ? 'has-error' : ''}`}>
      <div className={`modern-picker-container ${isFocused ? 'focused' : ''} ${hasValue ? 'has-value' : ''} ${disabled ? 'is-disabled' : ''}`}>
        <select
          ref={selectRef}
          id={id}
          className="modern-picker-select"
          value={value}
          onChange={(e) => onChange && onChange(e)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          required={required}
          autoFocus={autoFocus}
          {...props}
        >
          {children}
        </select>

        {label && !(hideLabelOnSelect && hasValue) && (
          <label
            htmlFor={id}
            className={`modern-picker-label ${isFocused || hasValue ? 'floating' : ''}`}
          >
            {label}
            {required && <span className="required-star">*</span>}
          </label>
        )}
        <span className="modern-picker-arrow" />
      </div>
      {error && <div className="modern-picker-error">{error}</div>}
    </div>
  );
}

export default Picker;


